export default "__VITE_ASSET__XY9TzuCG__"